<template>
	<div class="reset">
		<navbar></navbar>

		<section class="content">
			<md-card>
				<md-card-header>
					<div class="md-title">Új jelszó igénylés</div>
				</md-card-header>
				<md-card-content>
					Ezen a felületen új jelszót állíthat be a fiókjára. Ha mégsem szeretné megváltoztatni a jelszavát, hagyja figyelmen kívül.</br>
					<b>A jelszónak legalább 8 karakter hosszú szöveget kell megadni, legalább egy kis és nagybetű, valamint szám használatával!</b>
					<md-input-container class="col-md-6">
						<label>Új jelszó</label>
						<md-input v-model="password" type="password"></md-input>
					</md-input-container>
				</md-card-content>
				<md-card-actions>
					<md-button v-on:click="reset">Küldés</md-button>
				</md-card-actions>
			</md-card>
		</section>

	</div>
</template>

<script>
	import Navbar from './Navbar'
	import Api from '../../generated'

	export default {
		components: {
			Navbar
		},
		data(){
			return{
				password: undefined
			}
		},
		methods: {
			reset(){
				Api.ApiClient.instance.resetPassword({
					token: this.$route.params.token,
					password: this.password
				}, (error, data, response) => {
					if (error) {
						console.error(error);
						this.$bus.$emit('showToast','Hiba történt, ellenőrizze a megadott jelszót és próbálja meg újra');
						// TODO: show password validation errors
						// TODO: show expired token error
					} else {
						console.log(response);
						this.$bus.$emit('showToast','Sikeres jelszó átállítás, most már bejelentkezhet');
					}
				});
			}
		}
	}
</script>

<style scoped>
	.content{
		margin: 16px;
	}
</style>



// WEBPACK FOOTER //
// PasswordResetView.vue?31d1890c